// pages/MyOrders.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { API_BASE } from '../config';

const statusClass = {
  pending: 'badge-pending',
  paid: 'badge-paid',
  delivered: 'badge-delivered',
  cancelled: 'badge-cancelled',
};
const statusLabel = {
  pending: 'Pending Verification',
  paid: 'Paid - Preparing Delivery',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
};

function MyOrders() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }
    const fetchOrders = async () => {
      try {
        const res = await fetch(`${API_BASE}/orders/my`, { headers: { Authorization: `Bearer ${token}` } });
        if (!res.ok) throw new Error('Failed to fetch orders');
        setOrders(await res.json());
      } catch (err) {
        setError('Could not load your orders. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, [navigate]);

  if (loading) return <p className="page muted" style={{ textAlign: 'center', marginTop: '50px' }}>Loading your orders...</p>;
  if (error) return <p className="page" style={{ textAlign: 'center', color: '#ff4757', marginTop: '50px' }}>{error}</p>;

  return (
    <div className="page">
      <h2 className="display" style={{ fontSize: '26px' }}>My Orders</h2>

      {orders.length === 0 ? (
        <p className="muted" style={{ marginTop: '20px' }}>
          You haven't placed any orders yet. Head back to the homepage to browse plans.
        </p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginTop: '20px' }}>
          {orders.map((order) => (
            <div key={order._id} className="panel" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
              <div>
                <h3 style={{ margin: '0 0 4px' }}>{order.productName}</h3>
                <p className="muted" style={{ margin: '0 0 4px', fontSize: '14px' }}>
                  Qty: {order.quantity} &nbsp;•&nbsp; ₹{order.totalPrice}
                </p>
                <p style={{ margin: 0, fontSize: '12px', color: '#6b7285', fontFamily: 'JetBrains Mono, monospace' }}>
                  UPI-ORD-{order._id}
                </p>
                <p className="muted" style={{ margin: '4px 0 0', fontSize: '12px' }}>
                  Placed on {new Date(order.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                </p>
              </div>
              <span className={`badge-status ${statusClass[order.status] || 'badge-pending'}`}>
                {statusLabel[order.status] || 'Pending'}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default MyOrders;
